import { useT } from '../context/LanguageContext';
import { mockData } from '../mock';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight, MessageSquareHeart } from 'lucide-react';
import { api, pictureUrl } from '../lib/api';

const Stars = ({ value, size = 14 }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={size} className={n <= value ? 'text-[#ffb400] fill-[#ffb400]' : 'text-white/20'} />)}
  </div>
);

const ReviewsPreview = () => {
  const { t } = useT();
  const [data, setData] = useState({ reviews: [], count: 0, average: 0 });

  useEffect(() => {
    api.get('/reviews').then((r) => setData(r.data)).catch(() => {});
  }, []);

  const latest = data.reviews.slice(0, 3);

  return (
    <section id="anmeldingar" className="bg-black py-20 md:py-24 border-t border-white/5" data-testid="reviews-preview">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-[#ffb400] font-bold uppercase tracking-widest text-sm mb-2">{t('Anmeldingar')}</p>
            <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tighter" style={{ fontFamily: "'Oktah Round', sans-serif" }}>{t('Kva seier folk?')}</h2>
          </div>
          {data.count > 0 && (
            <div className="flex items-center gap-3" data-testid="reviews-preview-summary">
              <span className="text-4xl font-bold text-[#ffb400]" style={{ fontFamily: "'Oktah Round', sans-serif" }}>{data.average}</span>
              <div>
                <Stars value={Math.round(data.average)} size={16} />
                <p className="text-white/50 text-xs mt-1">{data.count} {data.count === 1 ? 'anmelding' : 'anmeldingar'}</p>
              </div>
            </div>
          )}
        </div>

        {latest.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="reviews-preview-list">
            {latest.map((r) => {
              const pic = pictureUrl(r.picture);
              return (
                <div key={r.id} data-testid="reviews-preview-card" className="rounded-3xl bg-[#1a1424] border border-white/5 p-6 flex flex-col gap-3">
                  <div className="flex items-center gap-3">
                    {pic ? <img src={pic} alt={r.name} className="w-10 h-10 rounded-full object-cover" /> : <div className="w-10 h-10 rounded-full bg-[#ff2e2e] text-black font-bold flex items-center justify-center">{r.name?.[0]?.toUpperCase()}</div>}
                    <div className="min-w-0">
                      <p className="text-white font-bold truncate">{r.name}</p>
                      <Stars value={r.rating} />
                    </div>
                  </div>
                  <p className="text-white/70 text-sm leading-relaxed line-clamp-4">{r.comment}</p>
                </div>
              );
            })}
          </div>
        ) : (
          <div data-testid="reviews-preview-empty" className="rounded-3xl border border-dashed border-white/15 p-10 text-center text-white/50">{t('Ingen anmeldingar enno – bli den første!')}</div>
        )}

        <div className="flex flex-col sm:flex-row justify-center gap-3 mt-10">
          <Link to="/anmeldelser" data-testid="reviews-preview-write-link" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-[#ffb400] text-black font-bold uppercase tracking-wide hover:bg-[#ffc533] transition-colors">
            <MessageSquareHeart size={18} /> {t('Skriv ei anmelding')}
          </Link>
          <Link to="/anmeldelser" data-testid="reviews-preview-all-link" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/20 text-white font-bold uppercase tracking-wide hover:border-[#ffb400] hover:text-[#ffb400] transition-colors">
            {t('Sjå alle')} <ArrowRight size={18} />
          </Link>
          <a href={mockData.tripadvisor} target="_blank" rel="noreferrer noopener" data-testid="reviews-tripadvisor-link" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-[#34E0A1] text-black font-bold uppercase tracking-wide hover:bg-[#5ce8b4] transition-colors">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 5.5c2.1 0 4 .5 5.7 1.4H22l-1.8 2a5.2 5.2 0 1 1-8.2 6.2A5.2 5.2 0 1 1 3.8 8.9L2 6.9h4.3C8 6 9.9 5.5 12 5.5Zm-5 3.9a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6Zm10 0a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6ZM7 11.3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/></svg>
            Tripadvisor
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsPreview;
